import {
  Divider,
  Icons,
  Tooltip,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { PreparedWorkload } from 'features/workload-optimization';

type PolicyStatusProps = {
  workload: PreparedWorkload;
};

export const PolicyStatus = ({ workload }: PolicyStatusProps) => {
  const isOverridden = workload.optimizationTypeState.isOverridden;

  return (
    <Stack position="relative" justifyContent="center">
      <Tooltip
        title={
          <Stack direction="row" gap={4}>
            <Typography variant="P12R">Optimization status:</Typography>
            <Typography variant="P12B">
              {isOverridden ? 'Overrides policy' : 'Follows policy'}
            </Typography>
          </Stack>
        }
      >
        <Box
          sx={{
            transform: 'rotate(45deg)',
            width: 16,
            height: 16,
            backgroundColor: tokens.theme.bg.structural.surfaceRaised,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
          }}
        >
          <Icons.Link
            size={12}
            weight="bold"
            color={tokens.theme.fg.structural.primary}
          />
          {isOverridden && (
            <Box
              sx={{
                borderLeft: '1px solid',
                borderColor: tokens.theme.border.structural.inverse,
                width: '1px',
                position: 'absolute',
                height: '90%',
                borderRadius: '2px',
              }}
            />
          )}
        </Box>
      </Tooltip>
      <Stack
        sx={{
          position: 'absolute',
          left: '50%',
          top: 0,
          bottom: 0,
          transform: 'translateX(-50%)',
        }}
      >
        <Divider orientation="vertical" />
      </Stack>
    </Stack>
  );
};
